import { RouterTabs } from '@components/header/router-tabs';
import { IconCheckmark } from '@components/icons/checkmark';
import { IconPlay } from '@components/icons/play';
import useQueryParams from '@hooks/use-query-params';

import { FilterHeader } from 'components/headers';
import { useStore } from 'models/Provider';

import { useOnboardingContext, useOnboardingFilterState } from './onboarding-config';

export const OnboardingHeader: React.FC = (props) => {
  const { t } = useStore();
  const { filters } = useOnboardingContext();
  const filterState = useOnboardingFilterState();

  return (
    <FilterHeader
      title={t('navigation.onboarding')}
      filters={filters}
      filterState={filterState}
      searchPlaceholder={t('applicants.header.search.placeholder')}
      tabs={<OnboardingTabs />}
      {...props}
    />
  );
};

const OnboardingTabs = () => {
  const { t } = useStore();
  const section = useQueryParams('section');
  const activeSection = section === 'completed' ? 'completed' : 'in_progress';

  return (
    <RouterTabs
      ariaLabel={t('onboarding.tabs.label')}
      activeSection={activeSection}
      tabs={[
        {
          label: t('onboarding.tabs.in_progress'),
          to: '/onboarding',
          section: 'in_progress',
          icon: <IconPlay />,
        },
        {
          label: t('onboarding.tabs.completed'),
          to: '/onboarding?section=completed',
          section: 'completed',
          icon: <IconCheckmark />,
        },
      ]}
    />
  );
};
